<app-modal [dismissible]="true"
           [autoZIndex]="true"
           [baseZIndex]="10000">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.strain.registry.details.equivalentModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-picklist
            [source]="availableEquivalentPartNumbers"
            [target]="selectedEquivalentPartNumbers"
            displayField="nameWithSAP"
            [sourceHeader]="'admin.partNumbers.create-modal.pick-list.equivalence.leftHeader' | translate"
            [targetHeader]="'admin.partNumbers.create-modal.pick-list.equivalence.rightHeader' | translate"
            (selectionChange)="onSelectionChange($event)">
        </app-picklist>
    </ng-container>
    <div class="modal-footer" modal-footer>
        <app-button type="simple" (click)="close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isUpdateInProgress"
                    (click)="onSave()">
            {{ 'generic.buttons.save' | translate }}
        </app-button>
    </div>
</app-modal>
